import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, withTheme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    height:'600px',
    [theme.breakpoints.down('sm')]: {
      height:'300px',
     },
   
  },
  textPrimary:{
    color: '#000',
   },
   textSecondary:{
    color: '#5f6368',
   },
   
   
});

const NoCurvePaper = withStyles({
  root: {
    backgroundColor:'#fff',
    borderRadius:0,
   
    // [theme.breakpoints.up('md')]: {
    //   minHeight:'600px',
    //  },
   
    display:'flex',
    alignItems:'center',
    flexDirection:'column',
    justifyContent:'center'
  }
})(Paper);

const CustomTypography = withStyles(styles)(function(props){
  const {children,className,variant,component} = props;
   return(
     <Typography className={className} variant={variant} component={component}>
          {children}
     </Typography>
   )
});

function Section2(props) {
  const { classes, theme } = props;

  return (
      <NoCurvePaper className={classes.root} theme={theme} elevation={0}>
        <CustomTypography className ={classes.textPrimary} variant="headline" component="h3">
        “If you want to know what a man's like, take a good look at how he treats his inferiors, not his equals.”
        </CustomTypography>
  
        <CustomTypography className ={classes.textSecondary} component="p" variant="subheading">
          ― J.K. Rowling, Harry Potter and the Goblet of Fire 
        </CustomTypography>
      </NoCurvePaper>
  );
}

Section2.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles,{withTheme:true})(Section2);


// WEBPACK FOOTER //
// ./src/component/home/section2.js